import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
`;

export const FooterPush = styled.div`
  height: 9vh;

  @media only screen and (max-width: 900px) {
    height: 11vh;
  }

  @media only screen and (min-width: 1400px) {
    height: 7vh;
  }
`;
